import dayjs from 'dayjs'

import type { PredictionEvent } from '@/services/prediction/types'

/**
 * Adapted from cdc-web `EventCard/hooks/useIsEventLive.ts`。
 *
 * 差异：去掉了 useCountdownTimer 的"到点自动翻转"定时器（卡片数据本身由外层
 * React Query 自适应轮询刷新——进行中的赛事 5s 一次——翻转延迟最多一个轮询
 * 周期，可接受）。判定逻辑 1:1 保留：status resolved 或无 event_date → false；
 * 否则 event_date 已到（≤ now）即视为 live。
 */
export function useIsEventLive(event?: PredictionEvent | null): boolean {
  if (!event || event.status === 'resolved' || !event.event_date) {
    return false
  }
  const eventDate = dayjs(event.event_date)
  const now = dayjs()
  return eventDate.isBefore(now) || eventDate.isSame(now)
}
